<template>

    <CRow>
        <CCol col="12" lg="10">
            <CCard>
                <CCardHeader>
                    <strong>{{ dish.title }}</strong>
                    <RestaurantTableOrderBadge />
                </CCardHeader>
                <CCardBody>
                    <CInput
                        v-model="ingredientGroup.title"
                        label="Название группы"
                        placeholder="Введите название группы"
                    />
                    <CRow>
                        <CCol
                            tag="label"
                            class="col-form-label">Активен</CCol>
                        <CCol sm="10">
                            <CSwitch
                                color="dark"
                                shape="pill"
                                variant="opposite"
                                :checked.sync="ingredientGroup.enabled"
                            />
                        </CCol>
                    </CRow>
                    <br><br>
                    <CRow class="pl-3 pb-3" />
                    <CRow class="pb-3">
                        <CCol sm="4">
                            <CSelect
                                horizontal
                                :options="ingredientsOptions"
                                :value.sync="selectedIngredient"
                                placeholder="Выберите модификатор..."
                            />
                        </CCol>
                        <CCol sm="8">
                            <CButton
                                color="primary"
                                class="ml-3"
                                @click="addIngredient">Добавить</CButton>
                        </CCol>
                        
                    </CRow>
                    <CRow>
                        <CCol>
                            <CInput
                                v-model="ingredientGroup.limit"
                                horizontal
                                label="Лимит ингредиентов"
                                placeholder="Введите лимит группы"
                            />
                        </CCol>
                    </CRow>
                    <CRow class="pl-3">
                        <table class="table">
                            <thead>
                                <th>&nbsp;</th>
                                <th>Название</th>
                                <th>Цена</th>
                                <th>&nbsp;</th>
                            </thead>
                            <draggable v-model="ingredients" tag="tbody">
                                <tr v-for="ingredient in ingredients" :key="ingredient.title">
                                    <td><CIcon
                                        :height="24"
                                        :content="$options.icons.cilCursorMove"
                                        class="handle" /></td>
                                    <td>{{ ingredient.title }}</td>
                                    <td>{{ ingredient.price }}</td>
                                    <td><CButton @click="removeIngredient(ingredient.id)"><CIcon :content="$options.icons.cilTrash" class="handle" /></CButton></td>
                                </tr>
                            </draggable>
                        </table>
                    </CRow>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="save">Сохранить</CButton>
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="goBack">Отмена</CButton>
                </CCardFooter>
            </CCard>
        </CCol>

    </CRow>
</template>

<script>
    import Vue from 'vue';
    import draggable from 'vuedraggable';
    import { cilCursorMove, cilTrash } from '@coreui/icons';

    export default {

        name: 'IngredientGroupsEdit',

        components: {
            draggable
        },

        icons: {
            cilCursorMove,
            cilTrash
        },

        data () {
            return {
                restaurant: {},
                dish: {},
                ingredientGroup: {
                    title: '',
                    dish_id: '',
                    limit: 0,
                    ingredients: [],
                    enabled: false,
                },
                ingredients: [],
                allIngredients: [],
                selectedIngredient: null
            }
        },

        computed: {
            ingredientsList: {
                get() {
                    return this.ingredients;
                },

                set(v) {
                    this.ingredients = v;
                }
            },
            ingredientsOptions: function() {
                const ingredientsOptions = [];
                this.allIngredients.forEach(ingredient => {
                    ingredientsOptions.push({
                        value: ingredient.id,
                        label: ingredient.title + ' - ' + ingredient.price + ' руб.'
                    });
                });
                return ingredientsOptions;
            }
        },
  
        mounted() {
            const restaurantId = parseInt(this.$route.params.id);
            const id = parseInt(this.$route.params.dish_id);
            const groupId = parseInt(this.$route.params.group_id);
            Vue.axios.get('/restaurants/' + restaurantId)
                .then(resp => {
                    this.restaurant = resp.data;
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
            Vue.axios.get('/restaurants/' + restaurantId + '/dishes/' + id)
                .then(resp => {
                    this.dish = resp.data;
                    this.ingredientGroup.dish_id = resp.data.id;
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
            Vue.axios.get(`/restaurants/${id}/dishes/ingredients-group/${groupId}`)
                .then(resp => {
                    this.ingredientGroup = resp.data;
                    this.ingredients = resp.data.ingredients;
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
            Vue.axios.get('/restaurants/' + restaurantId + '/ingredients')
                .then(resp => {
                    this.setAllIngredients(resp.data);
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
        },

        methods: {

            save() {
                let index = 0;
                this.ingredientGroup.ingredients = [];
                this.ingredientGroup.limit = +this.ingredientGroup.limit ? +this.ingredientGroup.limit : null;
                this.ingredientGroup.enabled = this.ingredientGroup.enabled;
                this.ingredients.forEach(ingredient => {
                    ingredient.position = ++index;
                    this.ingredientGroup.ingredients.push(ingredient.id);
                });
                Vue.axios.post(`/restaurants/${this.restaurant.id}/dishes/ingredient-groups/update/${this.ingredientGroup.id}`, this.ingredientGroup)
                    .then(() => {
                        this.$router.push({ path: `/restaurants/${this.restaurant.id}/dishes/${this.dish.id}/ingredient-groups` })
                    })
                    .catch(() => {
                        this.$root.$emit('showError', 'Ошибка сохранения.');
                    });
            },

            setAllIngredients(ingredients) {
                const _allIngredients = [];
                ingredients.forEach(ingredient => {
                    if(this.addIngredientOption(ingredient.id)) {
                        _allIngredients.push({
                            id: ingredient.id,
                            title: ingredient.title,
                            price: ingredient.price,
                            position: ingredient.position
                        });
                    }
                });
                this.allIngredients = _allIngredients;
            },

            addIngredientOption(id) {
                let contains = false;
                for(var i = 0; i < this.ingredients.length; i++) {
                    if(this.ingredients[i].id === id) {
                        contains = true;
                    }
                }
                return !contains;
            },

            addIngredient() {
                for(var i = 0; i < this.allIngredients.length; i++) {
                    if(this.selectedIngredient === this.allIngredients[i].id) {
                        this.ingredients.push({
                            id: this.allIngredients[i].id,
                            title: this.allIngredients[i].title,
                            price: this.allIngredients[i].price,
                            position: 0
                        });
                        delete this.allIngredients[i];
                        break;
                    }
                }
                this.setAllIngredients(this.allIngredients);
            },

            removeIngredient(id) {
                const _ingredients = []; 
                for(var i = 0; i < this.ingredients.length; i++) {
                    if(id != this.ingredients[i].id) {
                        _ingredients.push(this.ingredients[i]);
                    }
                }
                this.ingredients = _ingredients;
            },

            goBack() {
                this.$router.push({ path: `/restaurants/${this.restaurant.id}/dishes/${this.dish.id}/ingredient-groups` });
            }
        }
    }

</script>
<style scoped>
.handle {
  cursor: pointer;
}
</style>
